module.exports = __webpack_public_path__ + "static/img/codepic.67476c1f.png";